import { FormControl, FormGroup } from '@angular/forms';
import { CustomValidators } from '../custom-validators';
import { AuthService } from '../services/auth.service';
import { FormValidatorService } from '../services/form-validator.service';
import { Validators } from '../validators';
import { BaseForm } from './baseForm';
import { GetCurrenciesService } from './components/currency/getCurrencies.service';
export abstract class StepOneBase extends BaseForm {
  productName: string = '';
  productTypeId: string = '';
  stepId!: number;
  isTaxesApplied!: boolean;
  productNameField: any;
  stepForm!: FormGroup;
  public formValidator: FormValidatorService;
  form: any[] = [];
  hasQasatly!:boolean;
  productDescriptionField: any;


  public dueDateField = {
    'fieldName': 'Due date',
    'fieldNameAr': 'تارخ الاستحقاق',
    'fieldType': 'dueDate',
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`
      },
      {
        validatorFn: CustomValidators.dateInTheFuture,
        message: `${this.validationMsg.dateInTheFuture}`,
        messageAr: `${this.validationMsgAr.dateInTheFuture}`
      }
    ]
  };

  public productExpiryDateField = {
    'fieldName': 'Expiry date',
    'fieldNameAr': 'تاريخ انتهاء الصلاحية',
    'fieldType': 'expiryDate',
    validators: [
      {
        validatorFn: CustomValidators.dateInTheFuture,
        message: `${this.validationMsg.dateInTheFuture}`,
        messageAr: `${this.validationMsgAr.dateInTheFuture}`
      }
    ]
  };

  public customerBusinessNameField = {
    'fieldName': 'Customer',
    'fieldNameAr': 'العميل',
    'fieldType': 'customerBusinessName',
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`
      }
    ]
  };

  afterPaymentMessageField = {
    'fieldName': 'After Payment Message',
    'fieldNameAr': 'رسالة بعد الدفع',
    'fieldType': 'textarea',
  };

  invoiceNumberField = {
    'fieldName': 'Invoice number',
    'fieldNameAr': 'رقم الفاتورة',
    'fieldType': 'no-label-text-area',
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`
      },
      {
        validatorFn: Validators.minLength(2),
        message: `${this.validationMsg.minLength}2 characters`,
        messageAr: `${this.validationMsgAr.minLength}حرفان`
      },
      {
        validatorFn: Validators.pattern(/^[^\s].*$/),
        message: `${this.validationMsg.pattern}; cannot start with space`,
        messageAr: `${this.validationMsgAr.pattern}لا يمكن أن يبدأ بمسافة`
      },
      {
        validatorFn: CustomValidators.requiredNumber,
        message: `${this.validationMsg.requiredNumber}`,
        messageAr: `${this.validationMsgAr.requiredNumber}`
      }
    ]
  };

  claimNumberField = {
    'fieldName': 'Claim number',
    'fieldNameAr': 'رقم المطالبة',
    'fieldType': 'no-label-text-area',
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`
      },
      {
        validatorFn: Validators.minLength(2),
        message: `${this.validationMsg.minLength}2 characters`,
        messageAr: `${this.validationMsgAr.minLength}حرفان`
      },
      {
        validatorFn: Validators.pattern(/^[^\s].*$/),
        message: `${this.validationMsg.pattern}; cannot start with space`,
        messageAr: `${this.validationMsgAr.pattern}لا يمكن أن يبدأ بمسافة`
      },
      {
        validatorFn: CustomValidators.requiredNumber,
        message: `${this.validationMsg.requiredNumber}`,
        messageAr: `${this.validationMsgAr.requiredNumber}`
      }
    ]
  };

  showOnShopField: any;

  feesOnBuyerField = {
    'fieldName': 'Do you want the fees to be on the buyer?',
    'fieldType': 'no-label-toggle',
    'defaultValue': false
  };

  splitFeesField = {
    'fieldName': 'Do you want the fees to be split between buyer and seller?',
    'fieldType': 'no-label-toggle',
    'defaultValue': false
  };

  VATOnSellerField = {
    'fieldName': 'Do you want the VAT to be on buyer?',
    'fieldType': 'no-label-toggle',
    'defaultValue': true
  };

  showInEventsPage = {
    'fieldName': 'Show your event on Easykash Events page?',
    'fieldType': 'no-label-toggle',
    'defaultValue': true
  };

  marketingFeesEventsPage = {
    'fieldName': 'Do you want the marketing fees to be on the buyer?',
    'fieldType': 'no-label-toggle',
    'defaultValue': true
  };

  SendSmsField = {
    'fieldName': 'Do you want to send an SMS to the buyer after purchase? with a cost 0.5 EGP',
    'fieldType': 'no-label-toggle',
    'defaultValue': false
  };

  sendWhatsAppMsgAfterTrxToBuyer = {
    'fieldName': 'sendWhatsAppMsgAfterTrxToBuyer',
    'fieldType': 'no-label-toggle',
    'defaultValue': false
  };

  QasatlyDepositField = {
    'fieldName': 'Do you want Qasatly Deposit?',
    'fieldNameAr':'هل تريد مقدم قسطلى؟',
    'fieldType': 'tel',
    'defaultValue': 0,
    validators: [
      {
        validatorFn: CustomValidators.negativeNumber,
        message: `${this.validationMsg.min}0`,
        messageAr: `${this.validationMsgAr.min}الـ0`
      },
      {
        validatorFn: CustomValidators.requiredNumber,
        message: `${this.validationMsg.requiredNumber}`,
        messageAr: `${this.validationMsgAr.requiredNumber}`
      }
    ]
  };

  viewingCurrencyField = {
    'fieldName': 'Currency',
    'fieldType': 'no-label-select-list',
    'fieldValues': ['EGP'],
    'defaultValue': 'EGP',
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`
      }
    ]
  };

  taxesQuestionField = {
    'fieldName': 'TaxesQuestion',
    'fieldType': 'no-label-toggle',
    defaultValue: false,
  };

  taxesField = {
    'fieldName': 'Taxes',
    'fieldType': 'Taxes',
    'isStaticUI': true,
    defaultValue: 1,
    validators: [
      {
        validatorFn: Validators.min(0),
        message: `${this.validationMsg.min}0`,
        messageAr: `${this.validationMsgAr.min}الـ0`
      }
    ]
  };

  taxesTypeField = {
    'fieldName': 'Type',
    'fieldType': 'type',
    'isStaticUI': true,
    'defaultValue': 'Flat'
  };

  paymentOptionsField = {
    'fieldName': 'Payment options',
    'fieldType': 'payment_option',
    'isStaticUI': true,
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`
      }
    ]
  };

  cashFormField = {
    'fieldName': 'cash options',
    'fieldType': 'cashExpiryDate',
    'isStaticUI': true,
  };

  constructor(protected getCurrencies : GetCurrenciesService,protected auth:AuthService) {
      super();
      this.formValidator = new FormValidatorService();
  }
  private async setCurrency(){
    let currencies = await this.getCurrencies.make();
    this.viewingCurrencyField.fieldValues = currencies.map(
      (currency: { id: number; name: string }) => {
        return currency.name;
      }
    );
  }
  async asyncUpdateForm(){
    await this.setCurrency();
    this.hasQasatly =  await this.checkQasatly();
  }
  getForm(productName: any) {
    this.productNameField = this.getProductNameField(this.productName);
    this.productDescriptionField = this.getProductDescriptionField(this.productName);
    this.showOnShopField = this.getShowOnShopField(this.productName);
    const form = [
      this.productNameField,
      this.productDescriptionField,
      this.productExpiryDateField,
      this.afterPaymentMessageField,
      this.showOnShopField,
      this.feesOnBuyerField,
      this.splitFeesField,
      this.VATOnSellerField,
      this.showInEventsPage,
      this.marketingFeesEventsPage,
      this.SendSmsField,
      this.sendWhatsAppMsgAfterTrxToBuyer,
      this.viewingCurrencyField,
      this.taxesQuestionField,
      this.taxesField,
      this.taxesTypeField,
      this.paymentOptionsField,
      this.cashFormField,
      this.QasatlyDepositField
    ];
    if (productName == 'Invoice') {
      form.push(this.invoiceNumberField);
    } else if (productName == 'Claim') {
      form.push( this.claimNumberField, this.dueDateField, this.customerBusinessNameField);
    }


    return form;
  }

  getShowOnShopField(name: any) {
    let fieldName;
    if (name === 'Event') {
      fieldName = `Do you want this event on your shop?`;
    } else {
      fieldName = `Do you want to show this ${name.toLowerCase()} on your shop?`;
    }

    return {
      'fieldName': fieldName,
      'fieldType': 'no-label-toggle',
      'defaultValue': false
    };

  }

  getFieldValueByName(fieldValues: any[], name: string) {
    return (fieldValues.find(fv => fv.Field.name === name) || {}).fieldValue;
  }

  getProductNameField(name: any) {
    return {
      'fieldName': `${name} name`,
      'fieldNameAr': `إسم المنتج`,
      'fieldType': 'productName',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          message: 'Cannot be numbers only',
          validatorFn: CustomValidators.notInPattern(/^[0-9]*$/)
        },
        {
        validatorFn: Validators.pattern(/^[^\s].*$/),
        message: `${this.validationMsg.pattern}; cannot start with space`,
        messageAr: `${this.validationMsgAr.pattern}لا يمكن أن يبدأ بمسافة`
        },
        {
          validatorFn: Validators.minLength(2),
          message: `${this.validationMsg.minLength}2 characters`,
          messageAr: `${this.validationMsgAr.minLength}حرفان`
        }
      ]
    };
  }

  getProductDescriptionField(name: any) {
    return {
      'fieldName': `${name} description`,
      'fieldNameAr': `وصف المنتج`,
      'fieldType': 'textarea',
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.minLength(2),
          message: `${this.validationMsg.minLength}2 characters`,
          messageAr: `${this.validationMsgAr.minLength}حرفان`
        },
        {
        validatorFn: Validators.pattern(/^[^\s].*$/),
        message: `${this.validationMsg.pattern}; cannot start with space`,
        messageAr: `${this.validationMsgAr.pattern}لا يمكن أن يبدأ بمسافة`
        },
      ]
    };
  }

  getFormData() {
    return this.stepForm.value;
  }

  get isValid() {
    return this.stepForm.valid;
  }

  get hasCash() {
    try {
      return this.stepForm.controls['Payment options'].value
        .find((x: any) => (x.name == 'Cash' && x.isSelected));
    } catch (e) {
      return false;
    }
  }
  async checkQasatly() {
    try {
      return await this.auth.hasQassatlyMerchantId();
    } catch (e) {
      return false
    }
  }

  convertControls(name: string) {
    return this.stepForm.controls[name] as FormControl;
  }
}
